import React from 'react';
import { Nav, Navbar as RNavbar, NavItem } from 'react-bootstrap';
import styled from 'styled-components';

const Navbar = styled(RNavbar)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Footer = props => (
  <Navbar fixedBottom>
    Copyright &copy; 2017 - 2023 Wendy M. Tietz, LLC &nbsp; |  &nbsp; Questions or comments? <a href="mailto:wtietz@kent.edu">Email me</a>
  </Navbar>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js